/**
 * Icon name -> lucide-react name.
 *
 * Only the 93 icons the codebase actually imports are mapped.
 * `node scripts/checkLucideNames.mjs` asserts every target still exists in the
 * installed lucide-react.
 */
export const ICON_MAP = {
  // actions
  PlusOutlined: 'Plus',
  MinusOutlined: 'Minus',
  MinusCircleOutlined: 'CircleMinus',
  DeleteOutlined: 'Trash2',
  EditOutlined: 'Pencil',
  FormOutlined: 'SquarePen',
  SaveOutlined: 'Save',
  CopyOutlined: 'Copy',
  CloseOutlined: 'X',
  CheckOutlined: 'Check',
  ReloadOutlined: 'RotateCw',
  SyncOutlined: 'RefreshCw',
  SearchOutlined: 'Search',
  FilterOutlined: 'Filter',
  ClearOutlined: 'Eraser',
  UploadOutlined: 'Upload',
  CloudUploadOutlined: 'CloudUpload',
  DownloadOutlined: 'Download',
  PrinterOutlined: 'Printer',
  ShareAltOutlined: 'Share2',
  SwapOutlined: 'ArrowLeftRight',
  StopOutlined: 'Ban',
  LogoutOutlined: 'LogOut',
  MoreOutlined: 'Ellipsis',
  LoadingOutlined: 'LoaderCircle',
  TranslationOutlined: 'Languages',

  // status
  CheckCircleOutlined: 'CircleCheck',
  CheckCircleFilled: 'CircleCheckBig',
  CloseCircleOutlined: 'CircleX',
  ExclamationCircleOutlined: 'CircleAlert',
  InfoCircleOutlined: 'Info',
  QuestionCircleOutlined: 'HelpCircle',
  WarningOutlined: 'TriangleAlert',
  AlertOutlined: 'BellRing',
  NotificationOutlined: 'Megaphone',
  BellOutlined: 'Bell',

  // arrows and chevrons
  ArrowLeftOutlined: 'ArrowLeft',
  ArrowRightOutlined: 'ArrowRight',
  ArrowUpOutlined: 'ArrowUp',
  DownOutlined: 'ChevronDown',
  UpOutlined: 'ChevronUp',
  LeftOutlined: 'ChevronLeft',
  RightOutlined: 'ChevronRight',

  // people
  UserOutlined: 'User',
  UserAddOutlined: 'UserPlus',
  TeamOutlined: 'Users',
  ManOutlined: 'User',
  SmileOutlined: 'Smile',
  CrownOutlined: 'Crown',

  // money and commerce
  DollarOutlined: 'DollarSign',
  WalletOutlined: 'Wallet',
  CreditCardOutlined: 'CreditCard',
  BankOutlined: 'Landmark',
  PercentageOutlined: 'Percent',
  ShoppingCartOutlined: 'ShoppingCart',
  ShoppingOutlined: 'ShoppingBag',
  ShopOutlined: 'Store',
  GiftOutlined: 'Gift',
  TagOutlined: 'Tag',
  TagsOutlined: 'Tags',

  // files and documents
  FileTextOutlined: 'FileText',
  FileOutlined: 'File',
  FilePdfOutlined: 'FileType',
  FileImageOutlined: 'FileImage',
  PictureOutlined: 'Image',
  ReadOutlined: 'BookOpen',

  // time
  CalendarOutlined: 'Calendar',
  ClockCircleOutlined: 'Clock',
  FieldTimeOutlined: 'Timer',
  HistoryOutlined: 'History',

  // places and travel
  HomeOutlined: 'House',
  EnvironmentOutlined: 'MapPin',
  GlobalOutlined: 'Globe',
  CompassOutlined: 'Compass',
  CarOutlined: 'Car',
  CoffeeOutlined: 'Coffee',

  // security
  LockOutlined: 'Lock',
  KeyOutlined: 'KeyRound',
  SafetyOutlined: 'ShieldCheck',
  EyeOutlined: 'Eye',
  EyeInvisibleOutlined: 'EyeOff',

  // data and layout
  AppstoreOutlined: 'LayoutGrid',
  UnorderedListOutlined: 'List',
  BarChartOutlined: 'ChartColumn',
  PieChartOutlined: 'ChartPie',
  SettingOutlined: 'Settings',

  // misc
  StarOutlined: 'Star',
  HeartOutlined: 'Heart',
  MoonOutlined: 'Moon',
  ThunderboltOutlined: 'Zap',
  WifiOutlined: 'Wifi',
  MailOutlined: 'Mail',
  PhoneOutlined: 'Phone',
}
